import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { FileText, Download, Loader2 } from "lucide-react";

function fmtSize(n) {
  if (!n && n !== 0) return "";
  if (n < 1024) return `${n} o`;
  if (n < 1024 * 1024) return `${Math.round(n / 1024)} Ko`;
  return `${(n / (1024 * 1024)).toFixed(1)} Mo`;
}

export default function ChatAttachment({ att }) {
  const [url, setUrl] = useState(null);
  const [loading, setLoading] = useState(att.is_image);

  useEffect(() => {
    let revoked = null;
    if (att.is_image) {
      api.get(`/chat/files/${att.file_id}/download`, { responseType: "blob" })
        .then((r) => {
          const u = window.URL.createObjectURL(r.data);
          revoked = u;
          setUrl(u);
        })
        .catch(() => {})
        .finally(() => setLoading(false));
    }
    return () => { if (revoked) window.URL.revokeObjectURL(revoked); };
  }, [att.file_id, att.is_image]);

  const download = async () => {
    try {
      const r = await api.get(`/chat/files/${att.file_id}/download`, { responseType: "blob" });
      const u = window.URL.createObjectURL(r.data);
      const a = document.createElement("a");
      a.href = u; a.download = att.filename || "fichier";
      document.body.appendChild(a); a.click(); a.remove();
      window.URL.revokeObjectURL(u);
    } catch (e) { /* noop */ }
  };

  if (att.is_image) {
    return (
      <div className="mt-1.5" data-testid={`chat-attachment-${att.file_id}`}>
        {loading ? (
          <div className="w-48 h-32 bg-slate-100 rounded-sm flex items-center justify-center">
            <Loader2 className="w-5 h-5 animate-spin text-slate-400" />
          </div>
        ) : url ? (
          <a href={url} target="_blank" rel="noopener noreferrer">
            <img src={url} alt={att.filename} className="max-w-[260px] max-h-[220px] rounded-sm border border-slate-200 object-cover hover:opacity-90 transition-opacity" />
          </a>
        ) : (
          <button onClick={download} className="text-xs text-[#B8873A] underline">{att.filename}</button>
        )}
      </div>
    );
  }

  return (
    <button
      onClick={download}
      data-testid={`chat-attachment-${att.file_id}`}
      className="mt-1.5 flex items-center gap-2 bg-slate-50 border border-slate-200 rounded-sm px-3 py-2 hover:border-[#B8873A] transition-colors max-w-[260px]"
    >
      <FileText className="w-4 h-4 text-slate-500 shrink-0" />
      <div className="min-w-0 text-left">
        <div className="text-xs font-medium text-slate-700 truncate">{att.filename}</div>
        <div className="text-[10px] text-slate-400">{fmtSize(att.size)}</div>
      </div>
      <Download className="w-3.5 h-3.5 text-slate-400 shrink-0 ml-auto" />
    </button>
  );
}
